import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=9b3d0d7e&scoped=true&"
import script from "./customerForm.vue?vue&type=script&lang=js&"
export * from "./customerForm.vue?vue&type=script&lang=js&"
import style0 from "./customerForm.vue?vue&type=style&index=0&id=9b3d0d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3d0d7e",
  null
  
)

export default component.exports